import React from 'react';
import {View} from 'react-native';
import {List} from 'react-native-paper';
import TextM from "@common/components/text/TextM";
import {theme} from "@common/theme/theme";

const FAQComponent = ({faqs, withTitle = false}) => {

    return (
        <View style={{
            width: "100%",
            marginTop: 20,
            marginBottom: 40,
        }}>
            {withTitle && <TextM fontSize={25}
                                 fontWeight="bold"
                                 style={{marginBottom: 40, textAlign: "center"}}
                                 color={theme.colors.primary}>
                Questions fréquentes
            </TextM>}
            <List.AccordionGroup>
                {faqs.map((faq, index) => (
                    <List.Accordion
                        key={index}
                        left={() => <TextM fontSize={16} fontWeight={'SemiBold'} color={theme.colors.primary}
                                           wrap>{faq.question}</TextM>}
                        title={""}
                        id={index.toString()}
                        style={{borderWidth: 1, borderColor: theme.colors.lightMore, marginHorizontal: 5}}
                    >
                        <View style={{paddingHorizontal: 20, paddingVertical: 14}}>
                            <TextM wrap>{faq.answer}</TextM>
                        </View>
                    </List.Accordion>
                ))}
            </List.AccordionGroup>
        </View>
    );
};

export default FAQComponent;
